import { Box, IconButton } from '@mui/material';
import PlayArrow from '@mui/icons-material/PlayArrow';
import Pause from '@mui/icons-material/Pause';
import VolumeMute from '@mui/icons-material/VolumeMute';
import VolumeOff from '@mui/icons-material/VolumeOff';

import {
	richTextVideoControlsWrapperStyles,
	videoControlIconStyles,
	videoControlsWrapperStyles,
	videoIconButtonStyles,
	videoHoverEffect,
} from './VideoContent.styles';

interface IVideoContentControls {
	dataTestId: string;
	isAudioControlsVisible: boolean;
	isExtraSmallScreen: boolean;
	isHoveredStylesShowed: boolean;
	isMuted: boolean;
	isPlaying: boolean;
	isPortraitVideo: boolean;
	isSmallScreen: boolean;
	onToggleMute: () => void;
	onTogglePlayback: () => void;
	richTextStylePosition?: string;
	videoControlsSx?: React.CSSProperties;
}

export default function VideoContentControls({
	dataTestId,
	isAudioControlsVisible,
	isExtraSmallScreen,
	isHoveredStylesShowed,
	isMuted,
	isPlaying,
	isPortraitVideo,
	isSmallScreen,
	onToggleMute,
	onTogglePlayback,
	richTextStylePosition,
	videoControlsSx = {},
}: Readonly<IVideoContentControls>) {
	return (
		<Box
			data-testid={dataTestId}
			sx={[
				videoControlsWrapperStyles(isSmallScreen, isPortraitVideo),
				videoControlsSx,
				richTextStylePosition ? richTextVideoControlsWrapperStyles(isExtraSmallScreen) : {},
				videoHoverEffect(isHoveredStylesShowed),
			]}
		>
			<IconButton sx={videoIconButtonStyles} onClick={onTogglePlayback} aria-label={isPlaying ? 'pause' : 'play'}>
				{isPlaying ? (
					<Pause data-testid="button_icon_video_pause" sx={videoControlIconStyles} />
				) : (
					<PlayArrow data-testid="button_icon_video_play" sx={videoControlIconStyles} />
				)}
			</IconButton>
			{isAudioControlsVisible ? (
				<IconButton
					sx={videoIconButtonStyles}
					onClick={onToggleMute}
					aria-label={isMuted ? 'Volume on' : 'Mute'}
				>
					{isMuted ? (
						<VolumeOff data-testid="button_icon_audio_off" sx={videoControlIconStyles} />
					) : (
						<VolumeMute data-testid="button_icon_audio_on" sx={videoControlIconStyles} />
					)}
				</IconButton>
			) : null}
		</Box>
	);
}
